/* DPS theme-owned tracking. Account-level app pixels and GTM tags require their own audit. */
(() => {
  if (window.dpsTrackingPrivacyBound) return;
  window.dpsTrackingPrivacyBound = true;
  window.dataLayer = window.dataLayer || [];
  const gtag = function () { window.dataLayer.push(arguments); };
  const denied = {analytics_storage:'denied',ad_storage:'denied',ad_user_data:'denied',ad_personalization:'denied'};
  gtag('consent', 'default', denied);
  let gtmLoaded = false;
  let ownsPixelQueue = false;
  let pixelInitialized = false;
  let pageViewSent = false;
  let productViewSent = false;
  const permitted = (method) => {
    try { return window.Shopify?.customerPrivacy?.[method]?.() === true; }
    catch (_) { return false; }
  };
  const sync = () => {
    const analytics = permitted('analyticsProcessingAllowed');
    const marketing = permitted('marketingAllowed') && permitted('saleOfDataAllowed');
    gtag('consent', 'update', {analytics_storage:analytics?'granted':'denied',ad_storage:marketing?'granted':'denied',ad_user_data:marketing?'granted':'denied',ad_personalization:marketing?'granted':'denied'});
    // This pre-existing container has not had its custom tags audited. Require both purposes before loading it.
    if (analytics && marketing && !gtmLoaded) {
      gtmLoaded = true;
      window.dataLayer.push({'gtm.start':Date.now(),event:'gtm.js'});
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://www.googletagmanager.com/gtm.js?id=GTM-TSVZZC2';
      document.head.appendChild(script);
    }
    if (analytics && marketing && !productViewSent) {
      const node = document.getElementById('DpsTrackingConfig');
      if (node) {
        try {
          const config = JSON.parse(node.textContent);
          if (config.product) {
            window.dataLayer.push({event:'view_item',ecommerce:{items:[config.product]}});
            productViewSent = true;
          }
        } catch (_) { /* Invalid optional analytics config must not affect shopping. */ }
      }
    }
    if (!marketing) {
      if (ownsPixelQueue && !window.fbq?.callMethod && Array.isArray(window.fbq?.queue)) {
        window.fbq.queue = window.fbq.queue.filter(args => args[0] !== 'track' && args[0] !== 'trackCustom');
        pageViewSent = false;
      }
      if (pixelInitialized && typeof window.fbq === 'function') window.fbq('consent', 'revoke');
      return;
    }
    if (!window.fbq) {
      ownsPixelQueue = true;
      const fbq = window.fbq = function () { fbq.callMethod ? fbq.callMethod.apply(fbq, arguments) : fbq.queue.push(arguments); };
      if (!window._fbq) window._fbq = fbq;
      fbq.push = fbq; fbq.loaded = true; fbq.version = '2.0'; fbq.queue = [];
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
    }
    window.fbq('consent', 'grant');
    if (!pixelInitialized) { window.fbq('init', '694065759231529'); pixelInitialized = true; }
    if (!pageViewSent) { window.fbq('track', 'PageView'); pageViewSent = true; }
    document.dispatchEvent(new CustomEvent('dps:privacy-ready'));
  };
  const load = () => {
    if (window.Shopify?.customerPrivacy) { sync(); return; }
    window.Shopify?.loadFeatures?.([{name:'consent-tracking-api',version:'0.1'}], error => { if (!error) sync(); });
  };
  document.addEventListener('visitorConsentCollected', sync);
  window.addEventListener('load', load, {once:true});
  load();
})();
